import React from 'react'
import Header from '../../common/Header'
import { makeStyles } from '@mui/styles'
import StepTwoBg from '../../../assets/image/desktop-background/bg-03.png'
import MobileBackGroundImage from '../../../assets/image/mobile-background/mobile-bg-02.jpg'
import TextFiled from '../../common/TextFiled'
import { BusinessIcon, LocationIcon, ProfileIcon } from '../../../assets/icon'
import { useFormik } from 'formik'
import Typo from '../../common/Typo'
import { stepOneSchema } from '../../../data/schema'
import Card from '../../common/Card'
import { useDispatch, useSelector } from 'react-redux'
import { setQulificationStore } from '../../../redux/reducers/getData'
import Footer from '../../common/Footer'
import StepOneLogo from '../../../assets/image/StepOneLogo'

const useStyles = makeStyles((theme) => ({
  body: {
    backgroundImage: `url(${StepTwoBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    minHeight: '100vh',
    height: '100%',
    width: '100vw',
  },
  text: {
    minHeight: '85vh',
    maxHeight: '80vh',
    overflowY: 'scroll',
    width: '99vw',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '50px',
    animation: `$lauchTime 600ms ${theme.transitions.easing.easeInOut}`
  },
  "@keyframes lauchTime": {
    "0%": {
      transform: "translate(200%)",
    },
    "100%": {
      transform: "translateY(0)",
    }
  },
  inputfiledgrup: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '20px'
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  filed: {
    maxWidth: '400px',
    width: '25vw',
  },
  filed01: {
    maxWidth: '400px',
    width: '25vw',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '20px'
  },
  reviText: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '10px'
  },
  stepOneContentDiv: {
    maxWidth: '1000px',
    display: 'grid',
    columnGap: '1rem',
    gridTemplateColumns: '1.8fr 1fr',
    margin: '2.5rem'
  },
  stepOneSubText: {
    margin: '1rem 0'
  },
  "@keyframes shake": {
    "0%": {
      transform: "scale(1)",
    },
    "50%": {
      transform: "scale(1.2)",
    },
    "100%": {
      transform: "scale(1)",
    }
  },
  '@media (max-width: 1000px)': {
    body: {
      backgroundImage: `url(${MobileBackGroundImage})`,
    },
    text: {
      justifyContent: 'flex-start',
      margin: '0px'
    },
    stepOneContentDiv: {
      maxWidth: '100%',
      display: 'grid',
      columnGap: '1rem',
      gridTemplateColumns: '1fr',
      margin: '1rem'
    },
    filed: {
      width: '100%'
    },
    form: {
      padding: '1rem 0'
    },
    reviText: {
      rowGap: '1rem',
      padding: '0 1rem',
      margin: '1rem 0',
      width: '100%'
    },
    filed01: {
      maxWidth: '400px',
      width: '100%',
      gridTemplateColumns: '1fr',
      rowGap: '20px'
    }
  }
}))

function StepThree({ setStepTwo, setStepOne, onButtonClick }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const PreFiledBasicInformation = useSelector((state) => state.user.basicInformation)

  const { handleSubmit, handleChange, values, errors, handleBlur, touched } = useFormik({
    initialValues: {
      name: PreFiledBasicInformation?.first_name,
      lastname: PreFiledBasicInformation?.last_name,
      businessname: PreFiledBasicInformation?.business_name,
      location: PreFiledBasicInformation?.locations_count
    },
    touched: {
      name: '',
      lastname: '',
      businessname: '',
      location: ''
    },
    validationSchema: stepOneSchema,
    onSubmit: (value) => {
      setStepOne(false)
      setStepTwo(true)
      onButtonClick("pagetwo")
      let basicInformation = {
        first_name: value?.name,
        last_name: value?.lastname,
        business_name: value?.businessname,
        locations_count: value?.location
      }
      dispatch(setQulificationStore({ basicInformation }))
    }
  })

  return (
    <form className={classes.body}>
      <Header />

      <div className={classes.text}>

        <div className={classes.reviText}>
          <Typo variant='os01'> Welcome to </Typo>
          <StepOneLogo />
        </div>

        <Card className={classes.stepOneContentDiv}>
          <div>
            <Typo variant='os03F'>Get started with Revi!</Typo>

            <div className={classes.stepOneSubText}>
              <Typo variant='pp09'>We offer a variety of solutions to match your business’ needs.
                <br />Take this <b> 30 second questionnaire </b> to get started.
              </Typo>
            </div>
          </div>

          <div className={classes.form} >
            <Card margin="0 0 40px" className={classes.inputfiledgrup}>
              <div className={classes.filed01}>
                <TextFiled
                  label={'First name'}
                  id={'name'}
                  name={'name'}
                  value={values.name}
                  onChange={handleChange}
                  placeholder='First name'
                  icon={<ProfileIcon />}
                  defaultValue={PreFiledBasicInformation?.first_name}
                  onBlur={handleBlur}
                  touched={touched.name}
                  errors={errors.name}
                />
                <TextFiled
                  label={'Last name'}
                  id={'lastname'}
                  name={'lastname'}
                  value={values.lastname}
                  onChange={handleChange}
                  placeholder='Last name'
                  defaultValue={PreFiledBasicInformation?.last_name}
                  onBlur={handleBlur}
                  touched={touched.lastname}
                  errors={errors.lastname}
                />
              </div>

              <div className={classes.filed}>
                <TextFiled
                  label={'Business name'}
                  id={'businessname'}
                  name={'businessname'}
                  value={values.businessname}
                  onChange={handleChange}
                  placeholder="Type your business name"
                  icon={<BusinessIcon />}
                  defaultValue={PreFiledBasicInformation?.business_name}
                  onBlur={handleBlur}
                  touched={touched.businessname}
                  errors={errors.businessname}
                />
              </div>

              <div className={classes.filed}>
                <TextFiled
                  label={'Number of locations'}
                  id={'location'}
                  name={'location'}
                  value={values.location}
                  onChange={handleChange}
                  placeholder="Type number of locations"
                  icon={<LocationIcon />}
                  defaultValue={PreFiledBasicInformation?.locations_count}
                  onBlur={handleBlur}
                  touched={touched.location}
                  errors={errors.location}
                />
              </div>
            </Card>
          </div>

        </Card>

      </div>
      <Footer
        buttonText="Get started"
        isDisable={true}
        onSubmit={handleSubmit}
      />

    </form >
  )
}

export default StepThree
